export enum koCategory {
  '전체',
  '기숙사',
  '시설운영',
  '진로/취업',
  '학적/교과/장학',
  '학생지원/행사/동아리',
  '기획/예산/홍보',
  '대외협력',
  '권익소통',
  '자치회',
  '기타',
}

export enum enCategory {
  'All',
  'dormitory',
  'facility',
  'career/job',
  'register/scholarship',
  'student support/event/club',
  'planning/budget/public relations',
  'external cooperation',
  'rights/interest communication',
  'student council',
  'etc',
}
